var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCitiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 43.17 37.444 h -7.339 v 35.889 h 7.339 V 37.444 z M 49.899 37.503 v 6.729 h 6.179 v 20.247 c 0 2.793 0.767 5.037 2.243 6.729 c 1.476 1.752 3.443 2.616 5.923 2.676 c 2.459 0.059 4.643 -0.492 6.493 -1.633 l 0.117 -0.059 v -0.118 l 1.752 -6.828 l -0.433 0.275 c -1.968 1.201 -3.777 1.791 -5.431 1.791 c -2.282 0 -3.442 -1.358 -3.442 -4.034 V 44.232 h 7.496 v -6.73 h -7.496 V 26.288 l -7.222 3.876 v 7.339 L 49.899 37.503 L 49.899 37.503 z M 85.415 37.444 h -7.398 v 35.889 h 7.398 V 37.444 z M 31.62 43.091 l -0.158 -0.118 c -3.384 -4.112 -7.615 -6.12 -12.691 -6.12 c -5.312 0 -9.681 1.633 -13.183 4.86 C 1.869 45.118 0 49.702 0 55.447 s 1.869 10.291 5.588 13.735 c 3.443 3.226 7.871 4.821 13.183 4.821 c 5.077 0 9.346 -2.027 12.691 -6.08 l 0.158 -0.118 l -4.152 -5.017 l -0.157 0.157 c -2.696 2.676 -5.588 4.053 -8.697 4.053 c -3.247 0 -5.923 -1.102 -8.048 -3.286 c -2.145 -2.145 -3.168 -4.92 -3.168 -8.265 s 1.023 -6.139 3.168 -8.323 c 2.125 -2.125 4.801 -3.227 8.048 -3.227 c 3.109 0 6.001 1.377 8.697 4.053 l 0.157 0.158 L 31.62 43.091 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,70,133)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 39.451 31.541 c 2.893 -2.951 6.12 -5.194 9.799 -6.788 c 3.542 -1.535 7.319 -2.283 11.215 -2.283 c 3.877 0 7.654 0.748 11.275 2.283 c 3.6 1.594 6.827 3.837 9.72 6.788 l 0.118 0.099 H 90 l -0.315 -0.492 c -3.345 -4.703 -7.674 -8.421 -12.868 -11.137 c -5.195 -2.696 -10.606 -4.014 -16.351 -4.014 c -5.686 0 -11.176 1.318 -16.371 4.014 c -5.195 2.715 -9.523 6.434 -12.849 11.136 l -0.334 0.492 h 8.481 L 39.451 31.541 L 39.451 31.541 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(238,28,37)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 43.17 37.444 h -7.339 v 35.889 h 7.339 V 37.444 z M 49.899 37.503 v 6.729 h 6.179 v 20.247 c 0 2.793 0.767 5.037 2.243 6.729 c 1.476 1.752 3.443 2.616 5.923 2.676 c 2.459 0.059 4.643 -0.492 6.493 -1.633 l 0.117 -0.059 v -0.118 l 1.752 -6.828 l -0.433 0.275 c -1.968 1.201 -3.777 1.791 -5.431 1.791 c -2.282 0 -3.442 -1.358 -3.442 -4.034 V 44.232 h 7.496 v -6.73 h -7.496 V 26.288 l -7.222 3.876 v 7.339 L 49.899 37.503 L 49.899 37.503 z M 85.415 37.444 h -7.398 v 35.889 h 7.398 V 37.444 z M 31.62 43.091 l -0.158 -0.118 c -3.384 -4.112 -7.615 -6.12 -12.691 -6.12 c -5.312 0 -9.681 1.633 -13.183 4.86 C 1.869 45.118 0 49.702 0 55.447 s 1.869 10.291 5.588 13.735 c 3.443 3.226 7.871 4.821 13.183 4.821 c 5.077 0 9.346 -2.027 12.691 -6.08 l 0.158 -0.118 l -4.152 -5.017 l -0.157 0.157 c -2.696 2.676 -5.588 4.053 -8.697 4.053 c -3.247 0 -5.923 -1.102 -8.048 -3.286 c -2.145 -2.145 -3.168 -4.92 -3.168 -8.265 s 1.023 -6.139 3.168 -8.323 c 2.125 -2.125 4.801 -3.227 8.048 -3.227 c 3.109 0 6.001 1.377 8.697 4.053 l 0.157 0.158 L 31.62 43.091 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,70,133)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 39.451 31.541 c 2.893 -2.951 6.12 -5.194 9.799 -6.788 c 3.542 -1.535 7.319 -2.283 11.215 -2.283 c 3.877 0 7.654 0.748 11.275 2.283 c 3.6 1.594 6.827 3.837 9.72 6.788 l 0.118 0.099 H 90 l -0.315 -0.492 c -3.345 -4.703 -7.674 -8.421 -12.868 -11.137 c -5.195 -2.696 -10.606 -4.014 -16.351 -4.014 c -5.686 0 -11.176 1.318 -16.371 4.014 c -5.195 2.715 -9.523 6.434 -12.849 11.136 l -0.334 0.492 h 8.481 L 39.451 31.541 L 39.451 31.541 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(238,28,37)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitiLogo);
export default __webpack_public_path__ + "static/media/citi-logo.8b7d9d199b86a28690f1df34fbf90a68.svg";
export { ForwardRef as ReactComponent };